import LanguagesPageView from "./LanguagesPageView";

function LanguagesPage() {
  return <LanguagesPageView />;
}

export default LanguagesPage;
